import app from '@/app';

/* @ngInject */
function Service($uibModal, AlertService) {
  this.confirm = function confirm(
    title,
    question,
    solution,
    params,
    purpose,
    icon,
    action,
    callback
  ) {
    return $uibModal
      .open({
        component: 'confirmDialog',
        resolve: {
          bindings: function () {
            return {
              title: title,
              question: question,
              params: params,
              purpose: purpose,
              icon: icon,
              action: action
            };
          }
        }
      })
      .result.then(function () {
        var promise = callback();
        promise.then(function () {
          AlertService.success(solution, params);
        });
      });
  };

  this.confirmDelete = function (params, callback) {
    var arity = params.count && params.count > 1 ? 'all' : 'one';
    this.confirm(
      'entity.delete.title',
      'entity.delete.' + arity + '.question',
      'entity.delete.' + arity + '.solution',
      params,
      'btn-danger',
      'fa-trash',
      'action.delete',
      callback
    );
  };

  this.confirmDuplicate = function (message) {
    return $uibModal
      .open({
        component: 'confirmDialog',
        resolve: {
          bindings: function () {
            return {
              title: '',
              question: message,
              params: null,
              purpose: 'btn-warning',
              icon: 'fa-copy',
              action: 'duplicatePlansForProject.confirm'
            };
          }
        }
      })
      .result.then(
        function () {
          return true;
        },
        function () {
          return false;
        }
      );
  };
	
  this.confirmCheckUpdatedDependencies= function(message) {
		return $uibModal
			.open({
				component: 'confirmDialog',
				resolve: {
					bindings: function() {
						return {
							title: '',
							question: message,
							params: null,
							purpose: 'btn-warning',
							icon: 'fa-refresh',
							action: 'updatedDependencies.confirm'
						};
					}
				}
			})
			.result.then(
				function() {
					return true;
				},
				function() {
					return false;
				}
			);
	};

    this.confirmSyncApiKartado= function(message) {
		return $uibModal
			.open({
				component: 'confirmDialog',
				resolve: {
					bindings: function() {
						return {
							title: '',
							question: message,
							params: null,
							purpose: 'btn-warning',
							icon: 'fa-refresh',
							action: 'apiKartadoSync.confirm'
						};
					}
				}
			})
			.result.then(
				function() {
					return true;
				},
				function() {
					return false;
				}
			);
	};

  this.confirmPlanNote = function (message, note, placeHolder, params) {
    return $uibModal
      .open({
        component: 'confirmDialog',
        resolve: {
          bindings: function () {
            return {
              title: message,
              question: '',
              params: params || null,
              purpose: 'btn-warning',
              icon: 'fa-solid fa-book',
              action: 'planNote.confirm',
              showInput: true,
              inputLabel: '',
              inputPlaceholder: placeHolder,
              note: note
            };
          }
        }
      })
      .result.then(
        function (result) {
          return result;
        },
        function () {
          return { confirmed: false, text: null };
        }
      );
  };

  this.confirmRemoveDuplicatedMeasurements = function (message) {
    return $uibModal
      .open({
        component: 'confirmDialog',
        resolve: {
          bindings: function () {
            return {
              title: '',
              question: message,
              params: null,
              purpose: 'btn-warning',
              icon: 'fa-refresh',
              action: 'updatedDependencies.confirm'
            };
          }
        }
      })
      .result.then(
        function () {
          return true;
        },
        function () {
          return false;
        }
      );
  };

  this.alertMessage = function (message) {
    return $uibModal.open({
      component: 'warnDuplicateDialog',
      size: 'lg',
      resolve: {
        bindings: function () {
          return {
            message: message
          };
        }
      }
    });
  };

  this.alertMessageListError = function (count, errorList) {
    return $uibModal.open({
      component: 'warnDuplicateDialog',
      size: 'lg',
      resolve: {
        bindings: function () {
          return {
            message: count,
            errorList: errorList
          };
        }
      }
    });
  };

}

app.service('DialogService', Service);
